import React from 'react'

function DisplaySize({ size, color, strokeWidth }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.5 7.5H16.5V10.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16.5 7.5L13 11" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.5 16.5L11 13" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.5 16.5H7.5V13.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}

export default DisplaySize